export default {
  namespaced: true,
  state: {
    type:"SiteQueryModel",
    isOnSortSearch: false,
    sort_by: "",
    sort_direction: "DESC",
    excluded_rows:[],
    payload: {
      site_id: [],
      consumption_start_date: "",
      consumption_end_date: "",
      columns: [
        "site_name",
        "site_id",
        "category_name",
        "consumed_at"
      ],
      
      selected_columns: ["consumed_at","site_name","category_name"],
      measures: []
    }
  },
  getters: {
    getPayload: state => {
      return state.payload
    },
  },
  mutations: {
        
    updateExcludedRows(state, rownr) {
      if (rownr && rownr.length) {
        state.excluded_rows = [...state.excluded_rows, ...rownr];
      } else {
        state.excluded_rows = [];
      }
    },
    updateIsOnSortSearch(state, isOnSortSearch) {
      state.isOnSortSearch = isOnSortSearch;
    },
    updateSortBy(state, newSortBy) {
      state.sort_by = newSortBy;
    },
    updateSortDirection(state, newSortDirection) {
      state.sort_direction = newSortDirection;
    },
    updateStartDate(state, newStartDate) {
      state.payload.consumption_start_date = newStartDate;
    },
    updateEndDate(state, newEndDate) {
      state.payload.consumption_end_date = newEndDate;
    },
    updateSiteIds(state, newSiteIds) {
      state.payload.site_id = newSiteIds;
    },
    updateMeasures(state, newMeasures) {
      state.payload.measures = newMeasures;
    },
    updatePayload(state, newPayload) {
      state.payload = newPayload;
    }
  }
};
